import { createRoot } from 'react-dom/client';

import '@/styles/globals.css';
import '@paladigm/answer-visuals/style.css';
import '@shared/lib/i18n/config';
import './impersonation-boot';

import { App } from './App';

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(<App />);
